const serviceConfig = {};
// url.baseUrl = 'http://101.254.99.130:28501/api'; // 测试
// 登录 退出 对话接口用的都是本接口

// 本地开发
// serviceConfig.accountBaseUrl = "/api"; // 线上 华为云
// serviceConfig.baseUrl = "/api";

// 测试
// serviceConfig.accountBaseUrl = 'http://8.130.118.113:9110/account/';
// serviceConfig.baseUrl = 'http://8.130.118.113:8080/carebot/api/';

// 上线后
serviceConfig.accountBaseUrl = 'https://api.zhilanmed.com/account/'; // 线上 华为云
serviceConfig.baseUrl = 'https://api.zhilanmed.com/api/';

export default serviceConfig;



// WEBPACK FOOTER //
// ./src/common/serviceConfig.js